export type Branding = { companyName: string | null; logoDataUrl: string | null };
export const DEFAULT_BRANDING: Branding = { companyName: null, logoDataUrl: null };
